// Bootstrap
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { Link } from "react-router-dom";
import ListGroup from 'react-bootstrap/ListGroup';
// Libs
import { TwitterShareButton } from 'react-twitter-embed';

const Ventures = () => {
  return (
    <>
      <Row className="justify-content-md-center text-center" style={{marginTop: "48px"}}>
        <Col md="3">
          <span style={{fontSize: "3rem"}}>🚀</span>
          <h1 style={{fontSize: "2rem"}}>Ventures</h1>
          <p>5 ventures in the works</p>
          <p>List coming soon...</p>
        </Col>
      </Row>
      <Row className="justify-content-md-center text-center" style={{marginTop: "48px"}}></Row>
    </>
  );
};

export default Ventures;
